import { writable } from 'svelte/store';
export var data = writable([]);
export var currentDate = writable();
export var currentMonth = writable();
export var year = writable();
export var month = writable();
export var prevMonth = writable();
export var color = writable();
